/* eslint-disable */
export const LoginQuery = (email, password) =>
  `{login(email:\"${email}\",password:\"${password}\") {message,success,user_id,username,email,image,user_group{user_group_id,user_group_name},user_role{id,identifier}}}`;

export const ChangePasswordQuery = (user_id, old_password, new_password) =>
  `{changepassword(user_id:${user_id},old_password:\"${old_password}\",new_password:\"${new_password}\"){message,success}}`;
export const ForgotPasswordQuery = (email) =>
  `{forgotpassword(email:\"${email}\") {message,success}}`;
export const resetPasswordQuery = (reset_token, password) =>
  `{resetpassword(reset_token:\"${reset_token}\",password:\"${password}\") {message,success}}`;
export const getUserDetailsQuery = (userId) =>
  `{getuserdetail(user_id:${userId}){message,success,user_id,email,firstname,surname,image,user_group_name}}`;

//Manaeg ServiceType
export const createServiceType = (userId, name, abbreviation) =>
  `{createservicetype(user_id:${userId},name:\"${name}\",abbreviation:\"${abbreviation}\"){message,success,id,name,abbreviation}}`;
export const updateServiceType = (
  userId,
  service_type_id,
  name,
  abbreviation
) =>
  `{createservicetype(user_id:${userId},service_type_id:${service_type_id},name:\"${name}\",abbreviation:\"${abbreviation}\"){message,success,id,name,abbreviation}}`;
export const getServiceType = (userId, start, end) =>
  `{servicetypelist(user_id:${userId},start:${start},limit:${end}) {message,success,is_last,service_type_list{id,name,abbreviation}}}`;
export const deleteServiceType = (userId, id) =>
  `{removeservicetype(id:${id},user_id:${userId}) {message,success}}`;

//Manaeg FinanceType
export const createFinanceType = (userId, name, abbreviation) =>
  `{createfinancingtype(user_id:${userId},name:\"${name}\",abbreviation:\"${abbreviation}\"){message,success,id,name,abbreviation}}`;
export const updateFinanceType = (
  userId,
  financing_type_id,
  name,
  abbreviation
) =>
  `{createfinancingtype(user_id:${userId},financing_type_id:${financing_type_id},name:\"${name}\",abbreviation:\"${abbreviation}\"){message,success,id,name,abbreviation}}`;
export const getFinanceType = (userId, start, end) =>
  `{financingtypelist(user_id:${userId},start:${start},limit:${end}) {message,success,is_last,financing_type_list{id,name,abbreviation}}}`;
export const deleteFinanceType = (userId, id) =>
  `{removefinancingtype(id:${id},user_id:${userId}) {message,success}}`;

//Manage CarType
export const createCarType = (userId, name, abbreviation) =>
  `{createcartype(user_id:${userId},name:\"${name}\",abbreviation:\"${abbreviation}\"){message,success,id,name,abbreviation}}`;
export const updateCarType = (userId, car_type_id, name, abbreviation) =>
  `{createcartype(user_id:${userId},car_type_id:${car_type_id},name:\"${name}\",abbreviation:\"${abbreviation}\"){message,success,id,name,abbreviation}}`;
export const getCarType = (userId, start, end) =>
  `{cartypelist(user_id:${userId},start:${start},limit:${end}) {message,success,is_last,car_type_list{id,name,abbreviation}}}`;
export const deleteCarType = (userId, id) =>
  `{removecartype(id:${id},user_id:${userId}) {message,success}}`;

//Manage Insurance
export const getInsurance = (userId) => `{
    insurancelist(user_id:${userId})
    {
        message,
        success,
        is_last
        insurance_list
        {
            name
            id
            abbreviation
        }
    }
}`;

export const createInsurance = (userId, name, abbreviation) => `{
    createinsurance(user_id:${userId},name:\"${name}\",abbreviation:\"${abbreviation}\")
    {
        message,success,id,name,abbreviation
    }
}`;
export const updateInsurance = (userId, insurance_id, name, abbreviation) => `{
    createinsurance(user_id:${userId},insurance_id:${insurance_id},name:\"${name}\",abbreviation:\"${abbreviation}\")
    {
        message,success,id,name,abbreviation
    }
}`;
export const deleteInsurance = (userId, id) => `{
    removeinsurance(id:${id},user_id:${userId})
    {
        message,success
    }
}`;

//Manage CarBroker
export const getCarBroker = (userId) => `{
    carbrokerlist(user_id:${userId})
    {
        message,
        success,
        is_last
        car_broker_list
        {
            name
            id
            abbreviation
        }
    }
}`;
export const createCarBroker = (userId, name, abbreviation) => `{
    createcarbroker(user_id:${userId},name:\"${name}\",abbreviation:\"${abbreviation}\")
    {
        message,success,id,name,abbreviation
    }
}`;
export const updateCarBroker = (userId, car_broker_id, name, abbreviation) => `{
    createcarbroker(user_id:${userId},car_broker_id:${car_broker_id},name:\"${name}\",abbreviation:\"${abbreviation}\")
    {
        message,success,id,name,abbreviation
    }
}`;
export const deleteCarBroker = (userId, id) => `{
    removecarbroker(id:${id},user_id:${userId})
    {
        message,success
    }
}`;

//Manaeg CarBrandType
export const createCarBrandType = (userId, name, abbreviation, priority) =>
  `{createcarbrand(user_id:${userId},name:\"${name}\",abbreviation:\"${abbreviation}\",priority:${priority}){message,success,id,name,abbreviation}}`;
export const updateCarBrandType = (
  userId,
  car_type_id,
  name,
  abbreviation,
  priority
) =>
  `{createcarbrand(user_id:${userId},car_brand_id:${car_type_id},name:\"${name}\",abbreviation:\"${abbreviation}\",priority:${priority}){message,success,id,name,abbreviation}}`;
export const getCarBrandType = (userId, start, end) =>
  `{carbrandlist(user_id:${userId},start:${start},limit:${end}) {message,success,is_last,car_brand_list{id,name,abbreviation,priority}}}`;
export const getAllCarBrandType = (userId) =>
  `{carbrandlist(user_id:${userId}) {message,success,is_last,car_brand_list{id,name,abbreviation,priority}}}`;
export const deleteCarBrandType = (userId, id) =>
  `{removecarbrand(id:${id},user_id:${userId}) {message,success}}`;

//Manaeg Location
export const getLocation = (userId, start, end) =>
  `{locationlist(user_id:${userId},start:${start},limit:${end}) {message,success,is_last,location_list{id,name,abbreviation,image,priority}}}`;
export const deleteLocation = (userId, id) =>
  `{removelocation(id:${id},user_id:${userId}) {message,success}}`;

//Manaeg PersonList
export const getUserGroupList = (userId) =>
  `{usergrouplist(user_id:${userId}) {message,success,user_group_list{id,name,description}}}`;
export const getPersonList = (userId, start, end, locationId = 0, fetchAll = 0,userType) =>
  `{salespersonlist(user_id:${userId},start:${start},limit:${end}${locationId ? `,location_id:${locationId}` : ''}${fetchAll ? `,fetch_all:${fetchAll}` : ''}${userType ? `,userType:${userType}` : ''}) {message,success,is_last,sales_person_list{id,firstname,surname,email,is_active,location_id,location,viewonly_user,image,user_group_id,user_group_name}}}`;
export const deletePerson = (userId, id) =>
  `{removesalesperson(id:${id},user_id:${userId}) {message,success}}`;
export const getPersonListWithBrandList = (
  userId,
  selectedDate,
  start,
  end
) => `{
    salespersonlist(user_id:${userId},date:\"${selectedDate}\",start:${start},limit:${end}) {
        sales_person_list {
            id
            firstname
            location_id
            surname
            sales_person_brand_list {
                brand_name
                sale
                goal
                result
            }
        }
    }
}`;
export const getCarSellQuery = (
  sellId
) => `{
  getCarSell(car_sell_id:${sellId})
  {
    message,
    car_sell
    {
      id,car_brand_id,car_type_id,financing_type_id,service_type_id,car_broker_id,insurance_id,car_brand,car_type,insurance,financing_type,car_broker,service_type,sales_date,customer,car_model,gw_back,financing,service,sales_person_id,sales_person_name
    }
  }
}`;
export const setSalesPersonTeam = (
  userId,
  locationId,
  timestamp
) => `{
  salespersonChangeLocation(user_id:${userId},location_id:${locationId},date:${timestamp}){message}
}`;

//Manage CarSellYearlyPercentag
export const getCarSellGoalYearlyPercentage = (year) => `{getcarsellgoalYearlyPercentage(year:${year}) {message,success,percentages,percentages_cumulative}}`;
export const setCarSellGoalYearlyPercentage = (year, percentages) => `{setcarsellgoalYearlyPercentage(year:${year},percentage:${percentages}) {message,success}}`;

//DashBoard
export const getDashboardDetails = (userId, date) =>
  `{dashboard(user_id:${userId},date:\"${date}\")   { message,success,team_statistics{name,result},my_year{name,priority,result},this_month{name,brand_list{name,priority,sale,goal,result}},this_quarter_in_my_team{name,brand_list{name,priority,sale,goal,result}}}}`;

//Add Car Sell
export const addNewCarSell = (
  car_sell_id,
  userId,
  customer,
  car_model,
  sales_person_id,
  sales_date,
  car_brand_id,
  car_type_id,
  financing_type_id,
  service_type_id,
  gw_back,
  financing,
  service,
  car_broker_id,
  insurance_id
) =>
  `{addcarsell(${car_sell_id ? 'car_sell_id:'+car_sell_id+',' : ''}user_id:${userId},customer:\"${customer}\",car_model:\"${car_model}\",sales_person_id:${sales_person_id},sales_date:${sales_date},car_brand_id:${car_brand_id},car_type_id:${car_type_id},car_broker_id:${car_broker_id},insurance_id:${insurance_id},financing_type_id:${financing_type_id},service_type_id:${service_type_id},gw_back:${gw_back},financing:${financing},service:${service}){message,success}}`;

// Delete Car sell
export const deleteCarSell = (car_sell_id) => `{
  deletecarsell(car_sell_id:${car_sell_id}) {
    success,
    message
  }
}`;

//Add Car Sell
export const addUsedCarBought = (
    car_sell_id,
    userId,
    customer,
    sales_person_id,
    buy_date
) =>
    `{addcarbuy(${car_sell_id ? 'car_buy_id:'+car_sell_id+',' : ''}user_id:${userId},customer:\"${customer}\",sales_person_id:${sales_person_id},buy_date:${buy_date}){message,success}}`;

//Set Goal
export const getCarSellGoal = (userId, sales_person_id, year) => `{
    getcarsellgoal(
        user_id:${userId},
        sales_person_id:${sales_person_id},
        year:${year}
    ){
        message,
        success,
        car_brand_list{
            id,
            name,
            priority,
            goal_list{
                year,
                month,
                goal
            }
        }
    }
}`;
export const updatecarsellgoal = (
  userId,
  sales_person_id,
  year,
  goalData,
  yearlyGoalData
) => `{
    updatecarsellgoal(
        user_id:${userId},
        sales_person_id:${sales_person_id},
        year:${year},
        yearly_goal_data: ${yearlyGoalData},
        goal_data:${goalData}
       ) {
            message,
            success
        }
    }`;

//Statistics
export const getCarSellList = (
  userId,
  date
) => `{carselllist(user_id:${userId}, date:"${date}")
{
  car_sell_list
  {
    id,
    sales_date,
    sales_person_name,
    car_brand,
    customer,
    insurance,
    financing,
    financing_type,
    car_broker,
    service,
    service_type,
    car_model,
    gw_back
  }
}}`;
export const getMyStatistics = (userId, date) =>
  `{mystatistics(user_id:${userId},date:\"${date}\",start:0,limit:0) {message,success,is_last,my_year{id,name,sale,goal,result}}}`;
export const getTeamStatistics = (userId, team_id, date) =>
  `{teamstatistics(user_id:${userId},team_id:${team_id},date:\"${date}\",start:0,limit:0) {message,success,is_last,brand_list{id,priority,name},team_list{id,priority,team_name,sales_person_list{sales_person_name,sales_person_brand_list{brand_name,sale,goal,result,priority}}}}}`;
export const getTeamStatisticsBrands = (userId, team_id, date) =>
  `{teamstatistics(user_id:${userId},team_id:${team_id},date:\"${date}\",start:0,limit:0) {message,success,is_last,brand_list{id,priority,name}}}`;
export const getTimeStatistics = (userId, team_id, year) =>
  `{timestatistics(user_id:${userId},team_id:${team_id},year:${year},start:0,limit:0) {message,success,is_last,team_list{id,team_name,sales_person_list{id,sales_person_name,month_list{month,month_name,goal,state}}}}}`;

//Download PDF XLS
// export const exportcarsell = (userId,type,year,location_id) => `{exportcarsell(user_id:${userId},export_type:${type},year:${year},location_id:${location_id}){message,success}}`
export const exportcarsell = (userId, type, year, location_id) =>
  `{exportcarsell(user_id:${userId},export_type:${type},year:${year},location_id:${location_id}){message,success,fileBase64}}`;
export const addUserCarBrandPeriod = (userId, salesPersonId, startDate, endDate, carBrandId) =>
`{addUserCarBrandPeriod(user_id:${userId},sales_person_id:${salesPersonId},start_date:"${startDate}",end_date:"${endDate}",car_brand_id:${carBrandId}) {message, success}}`;
export const removeCarBrandFromUserCarBrandPeriod = (userId, salesPersonId, carBrandId) =>
`{removeCarBrandFromUserCarBrandPeriod(user_id:${userId},sales_person_id:${salesPersonId},car_brand_id:${carBrandId}) {message, success}}`;


